import type { Lead, LeadInterest } from '@shared/types';

async function json<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}) as Record<string, unknown>);
    throw new Error((body as { error?: string }).error || `Request failed (${res.status})`);
  }
  return res.json() as Promise<T>;
}

export const api = {
  submitLead: (body: {
    name: string;
    email: string;
    phone?: string;
    company?: string;
    message: string;
    interest: LeadInterest;
    sourcePath: string;
    _gotcha?: string;
  }) =>
    fetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(json<{ ok: true; id?: string }>),

  adminLogin: (password: string) =>
    fetch('/api/admin/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    }).then(json<{ token: string }>),

  adminLeads: (token: string) =>
    fetch('/api/admin/leads', { headers: { 'x-admin-token': token } }).then(json<{ leads: Lead[] }>),

  updateLead: (token: string, id: string, patch: { contacted?: boolean }) =>
    fetch(`/api/admin/leads/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'x-admin-token': token },
      body: JSON.stringify(patch),
    }).then(json<Lead>),
};
